import { CreateQuestionPaperReq, PaperGenMethodEnum, QuestionReqModel, SetAndQuestionMappingsModel } from "@boi/shared-models";
import { Injectable } from "@nestjs/common";
import { SectionQuestionMappingEntity } from "../entities/section-question-mapping.entity";
import { QuestionPapers } from "../entities/question-papers";
import * as moment from 'moment'
import { SectionWiseModel } from "../../model-paper/entities/section-wise-model.entity";
import { QuestionPaperModal } from "../../model-paper/entities/question-paper-modal";

@Injectable()
export class SectionQuestionsMappingAdapter {
  public convertDtoToEntity(parentDto: CreateQuestionPaperReq, serialNos: { serialQno: number, qno: number }[]): QuestionPapers {
    const questionPapers = new QuestionPapers();
    const qpCode = new QuestionPaperModal();
    qpCode.id = parentDto.qnpModelId;
    questionPapers.qpCode = qpCode;
    questionPapers.subject = parentDto.subject;
    questionPapers.setNo = parentDto.noOfSets;
    questionPapers.paperBundlerId = parentDto.paperBundlerId;
    questionPapers.status = 1;//TODO:
    questionPapers.createdAt = moment().unix().toString();
    questionPapers.createdBy = parentDto.userId;
    questionPapers.mode = parentDto.generationMethod === PaperGenMethodEnum.SYSTEM ? 'AI' : 'Manual';
    if (parentDto.difficulty) {
      questionPapers.easyPercentage = parentDto.difficulty.easy || 0;
      questionPapers.moderatePercentage = parentDto.difficulty.moderate || 0;
      questionPapers.hardPercentage = parentDto.difficulty.difficult || 0;
    } else {
      questionPapers.easyPercentage = 0;
      questionPapers.moderatePercentage = 0;
      questionPapers.hardPercentage = 0;
    }
    questionPapers.awarenessPercentage = 0;
    questionPapers.sensitivityPercentage = 0;
    questionPapers.creativityPercentage = 0;
    const qnos = [];
    const sectionsQuestionMapping = [];
    const sets = parentDto.generationMethod === PaperGenMethodEnum.SYSTEM ? this.getSectionMappingsOfSection(parentDto.sectionQuestionMappings, 1) : this.getSectionMappingsOfSection(parentDto.sectionQuestionMappings, parentDto.noOfSets);
    for (const dto of sets.sectionsMapping) {
      const entity = new SectionQuestionMappingEntity();
      entity.class = dto.className;
      entity.chapter = dto.chapter;
      entity.difficultyLevel = dto.difficultyLevel;
      entity.language = dto.language;
      entity.noOfQns = dto.noOfQns;
      entity.questionType = dto.questionType;
      entity.subject = dto.subject;
      entity.topic = dto.topic;
      entity.weightage = dto.weightage;
      entity.qnos = dto.qnos;
      const section = new SectionWiseModel();
      section.id = dto.sectionId;
      entity.section = section;
      qnos.push(...dto.qnos.split(','))
      sectionsQuestionMapping.push(entity);
    }

    questionPapers.qnos = qnos.toString();
    questionPapers.sectionsQuestionMapping = sectionsQuestionMapping;
    questionPapers.qnosOrder = JSON.stringify(serialNos);
    return questionPapers;
  }

  getSectionMappingsOfSection(sectionQuestionMappings: SetAndQuestionMappingsModel[], setNo: number) {
    return sectionQuestionMappings.find(rec => rec.setNo === setNo)
  }
}
